import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { StaticdataService,Country, State } from './staticdata.service';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  constructor(private staticdataService : StaticdataService) { }

  customPasswordValidator(config: any) : ValidatorFn {
    return (control: AbstractControl) : ValidationErrors|null => {
      let urlRegEx: RegExp = config.pattern;
      if (control.value && !control.value.match(urlRegEx)) {
        return {
          invalidMsg: config.msg
        };
      } else {
        return null;
      }
    };
  }

  countryValidator =() : ValidatorFn => {
    return (control: AbstractControl): ValidationErrors|null => {

        if(this.staticdataService.countryCache.find((c :Country) => c.countryCode == control.value?.countryCode)) {
          return null;
        } else {
          return {invalidMsg : "Invalid Country"};
        }
    }
  }

  stateValidator =(countryControl :  AbstractControl) : ValidatorFn => {
    return (control: AbstractControl): ValidationErrors|null => {
        if(countryControl?.value?.countryCode=="IN") {
          const selState = this.staticdataService.stateCache.find((c :State) => c.stateCode == control.value?.stateCode)
          if(selState) {
            return null;
          } else {
            return {invalidMsg : "Invalid State"};
          }
        } else {
          return null;
        }
    }
  }

  postalCodeValidator =(countryCtrl : AbstractControl|null) : ValidatorFn => {
    return (control: AbstractControl): ValidationErrors|null => {
      let country = "IN"
      if(countryCtrl) {
        const countryVal = countryCtrl.value;
        country = typeof countryVal === 'object' ? countryVal.countryCode : countryVal;
      }
      if(country=="IN") {
        if(!control.value.match("[1-9]{1}[0-9]{5}")) {
          return {invalidMsg : "Invalid postal code!"}
        }
      }
      return null;
    }
  }

  phoneNumbersValidation=() => {
    return (control : AbstractControl) :ValidationErrors|null => {
      if(!control.value) {
        return null;
      }
      const phoneNumbersText : string = control.value;
      const phoneNumbers = phoneNumbersText.split(/,|;/);
      let inValid = false;
      if(phoneNumbers.length >5) {
        return {invalidMsg : "More than 5 phone numbers"}
      }
      phoneNumbers.forEach((phoneNumber : string) => {
        if(!phoneNumber.match("^[\\+]{0,1}[0-9\\s]{10,14}$")) {
          inValid=true;
        }
      })
      if(inValid) {
        return {invalidMsg : "Invalid Phone Number"}
      }
      return null;
    }
  }

  emailValidation=() => {
    return (control : AbstractControl) :ValidationErrors|null => {
      if(!control.value) {
        return null;
      }
      const emailText : string = control.value;
      const emails = emailText.split(/,|;/);
      let inValid = false;
      if(emails.length >5) {
        return {invalidMsg : "More than 5 phone numbers"}
      }
      emails.forEach((email : string) => {
        if(!email.match(/^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/i)) {
          inValid=true;
        }
      })
      if(inValid) {
        return {invalidMsg : "Invalid email"}
      }
      return null;
    }
  }

  
}
